<script>
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ButtonAdd from "../ui/ButtonAdd.svelte";
    import TextInput from "../ui/TextInput.svelte";
    import SelectImageWithoutConfirmHandling from "../images/SelectImage_WithoutConfirmHandling.svelte";
    import SelectStamp from "./SelectStamp.svelte";
    import ToggleGroup from "./ToggleGroup.svelte";

    const dispatch = createEventDispatcher();

    let newStamp = {
        available_rarities: ["common", "rare"]
    };

    function confirm() {
        dispatch("add", newStamp);
        newStamp = {
            available_rarities: ["common", "rare"]
        };
        open = false;
    }

    function cancel() {
        open = false;
    }

    let open = false;

    $: valid = newStamp.name && newStamp.img_src && newStamp.available_rarities && newStamp.available_rarities.length > 0;
</script>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Stempel hinzufügen</DialogTitle>
        <DialogDescription class="dialog-description">
            Lege einen Stempel an, den du vergeben möchtest. Gebe dazu deinem Stempel einen Namen, wähle ein Bild aus und wähle aus, in welchen Seltenheiten er vorkommen soll.
        </DialogDescription>
        
        <form on:submit|preventDefault={confirm}>
            <TextInput
                label="Name"
                bind:value={newStamp.name}
            />
            <SelectStamp bind:img_src={newStamp.img_src}></SelectStamp>
            <!-- <label>Name
                <input bind:value={newDevice.name} type="text">
            </label> -->
            <!-- <label>Typ 
                <select bind:value={newDevice.type}>
                    <option value="device">Gerät</option>
                    <option value="nfc">NFC-Tag</option>
                </select>
            </label> -->
            
            <ToggleGroup options={["common", "rare"]} bind:selection={newStamp.available_rarities}/>

            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary" disabled={!valid}>
                    Hinzufügen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<!-- <button on:click={() => {open = true}}>Gerät hinzufügen</button> -->
<!-- <Button intent="primary" on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
    hinzufügen
</Button> -->

<ButtonAdd on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
</ButtonAdd>